import axios from 'axios';
import { get, patch } from 'helpers/api';
import { ADD_LEAD, UPDATE_LEAD } from 'bundles/project/actions/index';

import { toggleAlert } from '.';

export const updateLeadFields = (lead, fields) => (
  (dispatch) => {
    const path = getLeadPath(lead);

    return patch(path, { lead: fields }).then((updatedLead) => {
      dispatch({ type: UPDATE_LEAD, payload: updatedLead });
    });
  }
);

export const fetchLead = (projectId, id, isCurrent) => dispatch => (
  get(getLeadPath({ projectId, id })).then((lead) => {
    if (isCurrent()) dispatch({ type: ADD_LEAD, payload: lead });
  })
);

export const refreshLead = lead => (
  (dispatch) => {
    return get(getLeadPath(lead)).then((response) => {
      dispatch({ type: UPDATE_LEAD, payload: response });
    });
  }
);

export const updateLeadLocally = (lead, patch) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_LEAD, payload: { ...lead, ...patch } });
  };
};

export const inviteToViewDocs = (lead, inviteParams) => (
  (dispatch) => {
    const { saleOrLease, role, caFile } = inviteParams;

    const formData = new FormData();
    formData.append('sale_or_lease', saleOrLease);
    formData.append('role', role);
    if (caFile) formData.append('ca_file', caFile);

    return axios.post(lead.inviteToViewDocsPath, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(() => {
        dispatch(refreshLead(lead));
        dispatch(toggleAlert(`Success! Your Invite has been sent to ${lead.leadData.email}`));

      })
      .catch((error) => {
        const errorMsg = error.response.data[0] || 'There was an error sending you invite. Please contact support';
        dispatch(toggleAlert(errorMsg, true));
      });
  }
);

const getLeadPath = ({ id, projectId }) => `/projects/${projectId}/leads/${id}.json`;
